import { PortalConfigHelper } from './portals/portal-config-helper';
import { PortalType } from './portals/portal-type';

export enum PortalEnvironment {
  ppe = 'ppe',
  tst = 'tst',
  int = 'int',
  prod = 'prod',
}

const PARTNER_PORTAL_HOSTNAME: Record<PortalEnvironment, string> = {
  [PortalEnvironment.ppe]: 'partner.microsoft-ppe.com',
  [PortalEnvironment.int]: 'partner.microsoft-int.com',
  [PortalEnvironment.tst]: 'partner.microsoft-tst.com',
  [PortalEnvironment.prod]: 'partner.microsoft.com',
};

const SEOPS_PORTAL_HOSTNAME: Record<PortalEnvironment, string> = {
  [PortalEnvironment.ppe]: 'seops.microsoft-ppe.com',
  [PortalEnvironment.int]: 'seops.microsoft-int.com',
  [PortalEnvironment.tst]: 'seops.microsoft-tst.com',
  [PortalEnvironment.prod]: 'salesops.microsoft.com',
};

export function getPortalEnvironment(): any {
  const portalName = PortalConfigHelper.getInstance().getPortalConfig().portalName;
  const url = window.location.href.trim();

  if (portalName === PortalType.SEOps || portalName === PortalType.SalesOps) {
    if (url.includes(SEOPS_PORTAL_HOSTNAME.ppe)) return PortalEnvironment.ppe;
    if (url.includes(SEOPS_PORTAL_HOSTNAME.tst)) return PortalEnvironment.tst;
    if (url.includes(SEOPS_PORTAL_HOSTNAME.int)) return PortalEnvironment.int;
    if (url.includes(SEOPS_PORTAL_HOSTNAME.prod)) return PortalEnvironment.prod;
  } else {
    if (url.includes(PARTNER_PORTAL_HOSTNAME.ppe)) return PortalEnvironment.ppe;
    if (url.includes(PARTNER_PORTAL_HOSTNAME.tst)) return PortalEnvironment.tst;
    if (url.includes(PARTNER_PORTAL_HOSTNAME.int)) return PortalEnvironment.int;
    if (url.includes(PARTNER_PORTAL_HOSTNAME.prod)) return PortalEnvironment.prod;
  }

  return PortalEnvironment.tst;
}
